import { render, staticRenderFns } from "./CreateQuestionModal.vue?vue&type=template&id=38637709&scoped=true&"
import script from "./CreateQuestionModal.vue?vue&type=script&lang=ts&"
export * from "./CreateQuestionModal.vue?vue&type=script&lang=ts&"
import style0 from "./CreateQuestionModal.vue?vue&type=style&index=0&id=38637709&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38637709",
  null
  
)

export default component.exports